export const headerConstants = {
  UPDATE_HEADER_TITLE: "UPDATE_HEADER_TITLE"
}
